import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

//  店铺信息(基础信息)
export function getDecoration(params) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/info/decoration',
    method: 'get',
    params
  })
}

// 修改手机号
export function changeMobile(data) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/code/change/mobile',
    method: 'post',
    data
  })
}

// 修改店铺基础信息
export function changeDecoration(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/info/decoration',
    method: 'put',
    data
  })
}

// 获取省市区
export function addressList() {
  return axios.request({
    url: `${urlObj.crm}crm/resarea/gateway/area`,
    method: 'get'
  })
}

// 获取主营信息
export function getMainBusinessLines() {
  return axios.request({
    url: `${urlObj.crm}crm/tenant/info/getMainBusinessLines`,
    method: 'get'
  })
}

// 主营车型
export function findAll(params) {
  return axios.request({
    url: urlObj.crm + 'crm/acceptBasicInformation/getAllCarBrands',
    method: 'get',
    params
  })
}

// 主营品牌
export function getAllPartBrands(params) {
  return axios.request({
    url: urlObj.crm + 'crm/acceptBasicInformation/getAllPartBrands',
    method: 'get',
    params
  })
}

// 主营区域
export function getDictionariesItems(data) {
  return axios.request({
    url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItems',
    method: 'post',
    data
  })
}

// 主营配件(标准分组)
export function getlistAllGroup() {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllGroup',
    method: 'get'
  })
}

// 主营配件(标准名称)
export function getPartTypeId(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAllNameByPartTypeId',
    method: 'get',
    params
  })
}

// 保存主营车型
export function updateCarBrandForId(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/info/updateCarBrands',
    method: 'put',
    data
  })
}

// 保存品牌
export function updatePartBrandForId(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/info/updatePartBrands',
    method: 'put',
    data
  })
}

// 保存主营区域
export function updateBusinessAreaForId(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/info/updateBusinessArea',
    method: 'put',
    data
  })
}

// 保存主营配件
export function updatePartTypeForId(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/info/updatePartTypes',
    method: 'put',
    data
  })
}

// 获取照片
export function getImg(params) {
  return axios.request({
    url: urlObj.crm + 'crm/mywss/tenants/authinf/imgs',
    method: 'get',
    params
  })
}
